<template>
  <AttrSelect
    class="mt-2.5"
    label="类型"
    :value="shape.attrs.progressBarType"
    :disabled="!!attrDisabled"
    :options="[
      { label: '弧形进度条', value: 'arc' },
      { label: '直线进度条', value: 'line' }
    ]"
    @change="onTypeChange"
  />
  <!-- PivotXY -->
  <!-- <div v-if="shape.attrs.progressBarType === 'arc'" class="mt-2.5">
    <AttrPivotXY :shape="shape" />
  </div> -->
  <div
    v-if="shape.attrs.progressBarType == 'arc'"
    class="overflow-hidden mt-2.5 mb-2"
  >
    <ProgressExample />
  </div>
  <AttrGroup
    title="特性"
    :class="{ '-mt-7': shape.attrs.progressBarType == 'arc' }"
  >
    <ProgressAttrs class="" :shape="shape"
  /></AttrGroup>
  <AttrGroup title="填充"><ProgressImage :shape="shape" /></AttrGroup>
  <!-- 绑定数据 -->
  <attr-data-source :shape="shape" />
  <!-- 图片输出格式 -->
  <div>
    <AttrImgFomat :shape="shape" />
  </div>
</template>
<script lang="ts" setup>
import { Shape } from '@/services/shape';
import { useEditorStore } from '@/store/use-editor-store';
import { PropType, computed } from 'vue';

const props = defineProps({
  shape: {
    type: Object as PropType<Shape>,
    required: true
  }
});
const editorStore = useEditorStore();
const attrDisabled = computed(() => editorStore.attrDisabled);

const onTypeChange = (val: 'arc' | 'line') => {
  props.shape.setAttrs({
    progressBarType: val,
    growDirection: val == 'arc' ? 'positive' : 'to-right'
  });
};
</script>
